import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const Checkmark = ({ fill, size }) => (<svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
>
    <path
        fill={fill}
        d="M16 0L2 0C0.9 0 0 0.9 0 2L0 16C0 17.1 0.9 18 2 18L16 18C17.1 18 18 17.1 18 16L18 2C18 0.9 17.1 0 16 0ZM7 14L2 9 3.4 7.6 7 11.2 14.6 3.6 16 5 7 14Z" // eslint-disable-line max-len
    />
</svg>);

Checkmark.propTypes = {
    fill: PropTypes.string,
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

Checkmark.defaultProps = {
    size: 18,
};

export default connect(({ theme }) => ({
    fill: theme.primaryColor,
}))(Checkmark);



// WEBPACK FOOTER //
// ./src/client/Components/Icons/Checkmark.js